import { Native } from '@hb/hbridge';
import { env } from '@hb/NBridge/lib/h5';

export const hasCalendar = (() => Native.callNative({
  classMap: 'message/subscribe',
  method: 'msg_hasCalendarPermission',
  params: {},
  timeout: false,
}));

export const setCalendarSchedule = ((params) => Native.callNative({
  classMap: 'message/subscribe',
  method: 'msg_setCalendarSchedule',
  params: {
    title: params.title,
    alarm: 10,
    startTime: params.startTime,
    endTime: params.endTime,
    freq: params.freq,
    interval: params.interval,
    notes: params.notes || '',
  },
  timeout: false,
}));

export const isCalendarScheduleExist = ((params) => Native.callNative({
  classMap: 'message/subscribe',
  method: 'msg_isCalendarScheduleExist',
  params: {
    title: params.title,
    startTime: params.startTime,
    endTime: params.endTime,
  },
  timeout: false,
}));

export const deleteCalendarSchedule = ((params) => Native.callNative({
  classMap: 'message/subscribe',
  method: 'msg_deleteCalendarSchedule',
  params: {
    title: params.title,
    startTime: params.startTime,
    endTime: params.endTime,
    applyAllFuture: false,
  },
  timeout: false,
}));

function getNineAmTimestamp(h, m = 0) {
  // 获取当前日期
  const now = new Date();
  // 设置时间为9点
  const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
  tomorrow.setHours(h, m, 0, 0);
  // 返回时间戳
  return tomorrow.getTime() / 1000;
}

export const calenderList = [{
  startTime: `${getNineAmTimestamp(9)}`,
  endTime: `${getNineAmTimestamp(9, 10)}`,
  title: '会员签到奖励金翻倍，每日签到享不停',
}, {
  startTime: '1695873600',
  endTime: '1695877200',
  title: '您预约的百万出行基金正在瓜分中，手慢无！',
}];

export const openSystemSetting = () => {
  let method = '';
  if (env.isIOS) {
    method = 'goSetting';
  } else if (env.isAndroid) {
    method = 'openSystemSettingPage';
  }
  Native.callNative({
    method,
    classMap: 'business/user',
    params: {},
    timeout: false,
  });
};
